// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import icon from 'images/home-project-management-icon.png'
import projectManagementBg from 'images/home-project-management-bg.jpg'

import {
  DecoratedLink,
  DecoratedLinkText,
  SubtreeHeading,
  SubtreeIcon,
  SubtreeSectionWrapper,
} from './styles'

const ProjectManagement = () => (
  <SubtreeSectionWrapper bgImage={projectManagementBg}>
    <DecoratedLink
      className={'flex-direction-column'}
      id={'home-cta-project-management'}
      to={'/project-management'}>
      <SubtreeIcon
        alt={'Project Management Icon'}
        src={icon} />
      <DecoratedLinkText className={'margin-top-1'}>
        <SubtreeHeading>
          {'Project Management'}
        </SubtreeHeading>
      </DecoratedLinkText>
    </DecoratedLink>
  </SubtreeSectionWrapper>
)

export default ProjectManagement
